import React from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import { Link } from "react-router-dom";
import PercentIcon from 'mdi-react/PercentIcon';
import ToolTip from '../../../../../shared/components/ToolTip';

const CurrentlyListedPct = (props) => {
	const { buildingRes, location } = props;
	const totalUnits = buildingRes && buildingRes.residential_units > 0 ? buildingRes.residential_units : 0;
	const active = buildingRes && buildingRes.active_listings_rent > 0 ? buildingRes.active_listings_rent : 0;
	const pct = totalUnits > 0 ? (active / totalUnits) * 100 : null;
	const base_url = location.pathname.replace('analysis', 'listings');

	return (
		<Col md={12} xl={3} lg={6} xs={6}>
			<Card>
				<Link to={base_url}>
					<CardBody className="dashboard__booking-card card__link">
						<div className="dashboard__booking-total-container">
							<h5 className="dashboard__booking-total-title">
								{pct !== null ? `${pct.toFixed(1)}%` : '--'}
							</h5>
							<PercentIcon className="dashboard__trend-icon" />
						</div>
						<h5 className="dashboard__booking-total-description">Currently Listed
							<ToolTip title={"Share of residential units currently listed for rent. Hidden when the building's unit count is unknown."} />
						</h5>
					</CardBody>
				</Link>
			</Card>
		</Col>
	);
};

export default CurrentlyListedPct;
